<template>
    <div class="seomain">

        <div class="info-main">
            <div class="info-top"><span>调拨单号：</span>{{stinfo.code}}</div>
            <div class="info-mid"><h1>{{stinfo.logisticsnumber ? stinfo.logisticsnumber :'暂无物流单号'}} </h1><p>物流单号</p></div>
            <div class="info-bottom text-center">
                <dl><dt>调出仓库</dt><dd>{{stinfo.warehouse_out_name}}</dd></dl>
                <dl><dt>调入仓库</dt><dd>{{stinfo.warehouse_in_name}}</dd></dl>
            </div>
        </div>    
    
        <div class="tab-content">
            <div class="st-list-box pan-105">
                <div class="st-list" v-for="(v,k) in stlist" :key="k" :index="k">
                    <div class="st-list-top">
                        <div class="t-tit">{{v.sku}}</div>
                    </div>
                    <div class="st-list-main">
                        <p>品类：{{v.cname}}</p>
                        <p>品牌：{{v.brand}}</p>
                        <p>型号：{{v.model}}</p>
                        <p>配置：{{v.deploy}}</p>
                        <p>总数量：{{v.quantity}}</p>
                        <p>已签收数量：{{v.signinged}}</p>
                        <p>备注：{{v.remark}}</p>
                    </div>
                    <div class="st-list-bottom" @click="show = true;dialogActiveId = v.transfer_products_id;dialog_num = ''" v-if="flag != 'false'">
                        <p class="st-opt-btn">签  收</p>
                    </div>
                </div>
            </div>
        </div>
        
        <van-dialog v-model="show" show-cancel-button @confirm="edit_st2">
            <div class="mix-detail-box" v-if="dialogStlist">
                <h2>SKU：{{dialogStlist.sku}}</h2>
                <p>品类：{{dialogStlist.cname}}</p>
                <p>品牌：{{dialogStlist.brand}}</p>
                <p>型号：{{dialogStlist.model}}</p>
                <p>配置：{{dialogStlist.deploy}}</p>
                <p>总数量：{{dialogStlist.quantity}}</p>
                <p>已签收数量：{{dialogStlist.signinged}}</p>
                <el-input v-model="dialog_num" placeholder="请输入签收数量"></el-input>
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          dialog_num:'',
          show:!1,
          stlist:[],
          stinfo:{},
          paramsid:0,
          activeid:0,
          dialogActiveId: 1,  // 确定dialog显示数据的标识
      };
    },
    watch: {},
    computed: {
        flag () {
            return this.$route.params.flag;
        },
        dialogStlist () {
            let result = this.stlist.filter(item => item.transfer_products_id == this.dialogActiveId);
            return result[0]
        },
        id () {
            return this.$route.params.id;
        }
    },
    methods: {
        edit_st2:function(){
            let t = this;                
            if(this.$isEmpty(this.dialog_num)){
                return this.$toast('请先填写内容');
            }else{
                t.edit();
            }            
        },
        get_st_info:function(){       
            let paramsid = this.$route.params.id;
            this.$post(this.$api.stGetDiaoboQianshouList,{id:paramsid}).then(res=>{
                console.log(res)
                this.stlist = res.data.list;
                this.stinfo = res.data.info;
            });
        },   
        async edit () {
            let result = this.$post(this.$api.stSetDiaoboQianshouEdit,{id:this.dialogActiveId,stnum: this.dialog_num})
            this.$toast.success('已签收,请等待上级确认.');
            this.get_st_info()
        },
    },
    created() {
        this.get_st_info();
        window.h5sdk.ready(function() {
            window.h5sdk.biz.navigation.setTitle({ title: '调拨签收' });
        })
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.info-main{padding-top:10px;background: #345;margin-bottom:15px;}
.info-main .info-top{color:#9ab;line-height:2;margin:0 20px;}
.info-main .info-mid{text-align:center;color:#fff;}
.info-main .info-mid h1{line-height:2.2;font-weight: normal;}
.info-main .info-mid p{color:#9ab;}
.info-main .info-bottom{display:flex;background: #2f3e50;border-top:1px solid #9ab;margin-top:20px;padding:5px 0;}
.info-main .info-bottom dl{flex: 1;line-height:1.8;}
.info-main .info-bottom dt{color:#9ab;}
.info-main .info-bottom dd{color:#fff;}

.info-scan{margin-top:2.5em;margin-right:1.5em;}
.info-scan .van-icon{color:#0ba;font-size:50px;}

.info-detail-list{padding:10px 20px;background: #fff;}
.info-detail-list dl{display:flex;border-bottom:1px solid #e5e5e5;line-height:30px;padding-top:10px;padding-bottom:5px;}
.info-detail-list dt{flex:1;}
.info-detail-list .num{padding:0 10px;}
.info-detail-list .icon{color:#ddd;font-weight: bolder;font-size:24px;}

.status-00{font-weight:normal;}
.status-01{color:#43cf7c;}
.status-02{color:#ff5733;}
</style>